export default {
    name: '집중 화면',
    studentMessage: '지금은 선생님에게 집중해 주세요',
    teacherMessage: '집중 화면을 사용중이에요.',
    close: '해제하기',
};
